import { UserPermissionSetting } from '@/entity/UserPermissionSetting';
export class UserPermissionSettingVM extends UserPermissionSetting {
    /**
     *
     * @param {UserPermissionSettingVM} UserPermissionSettingVM domain UserPermissionSetting
     */
    // eslint-disable-next-line no-useless-constructor
    constructor(setting) {
        super(setting);
    }
    /** 상위 권한인지 여부 */
    get isDepth2() {
        // 상위 권한은 코드가 00으로 끝난다.
        const regex = /^\d{4}00$/;
        return regex.test(this.code);
    }
    /** depth1 + depth2 code + 00 */
    get parentCode() {
        return `${this.depth1Code}${this.depth2Code}00`;
    }
    /** 최상위 권한 이름 */
    get depth1Name() {
        return this._raw.depth1Name;
    }
    /** 최상위 권한 코드 */
    get depth1Code() {
        return this._raw.depth1Code;
    }
    /** 권한 카테고리 이름 */
    get depth2Name() {
        return this._raw.depth2Name;
    }
    /** 권한 카테고리 코드 */
    get depth2Code() {
        return this._raw.depth2Code;
    }
    /** 권한 코드 6자리 */
    get code() {
        return this._raw.code;
    }
    /** 권한 이름 */
    get name() {
        return this._raw.name;
    }
    /** 권한 설명 */
    get hint() {
        return this._raw.hint;
    }
    /** 권한 사용 여부 */
    get isAuthorized() {
        return this._raw.isAuthorized;
    }
    /** 권한 사용 여부 */
    set isAuthorized(value) {
        this._raw.isAuthorized = value;
    }
    /** 권한 사용 여부 */
    setIsAuthorized(value) {
        this._raw.isAuthorized = value;
    }
}
